import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchMouleSelectionShopDine } from "../AirlineImages/FetchModule";
import { fetchDineCategoryDropdown } from "./Dine/DineList/FetchCategoryOptions";
import { fetchCategorySelection, fetchTypeShopSelection } from "./FetchDropdownApi";
import { FetchLocationAirport, FetchSubModuleCentralized } from "./List/ListOptions";
import { fetchServicesCategoryDropdown } from "./Services/ServicesList/FetchCategoryOptions";
import { fetchShopCategoryDropdown } from "./Shop/ShopList/FetchCategoryOptions";
import { FetchSubModule } from "./Shop/ShopList/ShopListOptions";
export const getCentralizedShopDineDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedLandingPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "pageTitname_mandarinleZh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedShopCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedDineCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedServicesCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedLandingPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedShopCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedDineCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedServicesCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedShopListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedDineListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedServicesListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  centralizedZonePublic: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedZonePassenger: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedZoneLevels: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedShopListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchShopCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedServicesListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchServicesCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedDineListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchDineCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],

  //New shopdine fields
  centralizedBrands: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedRedirectUrl: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedTags: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedType: [
    {
      fieldName: "Web Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Web Image",
      placeholder: "Select Web Image",
      validation: { required: "Web Image is required" },
    },
    {
      fieldName: "Web Banner Image",
      fieldValue: "type_banner_image",
      className: "col-span-6",
      type: "image",
      name: "type_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Web Banner Image",
      placeholder: "Select Web Banner Image",
      validation: { required: "Web Banner Image is required" },
    },
    {
      fieldName: "Mobile Image",
      fieldValue: "mobile_image",
      className: "col-span-6",
      type: "image",
      name: "mobile_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Mobile Image",
      placeholder: "Select Mobile Image",
      validation: { required: "Mobile Image is required" },
    },
    {
      fieldName: "Mobile Banner Image",
      fieldValue: "mobile_banner_image",
      className: "col-span-6",
      type: "image",
      name: "mobile_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Mobile Banner Image",
      placeholder: "Select Mobile Banner Image",
      validation: { required: "Mobile Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Label",
      fieldValue: "label",
      className: "col-span-6",
      type: "text",
      name: "label",
      formType: "input",
      label: "Label",
      placeholder: "Enter Label",
      validation: { required: "Label is required" },
      note: "Label is required for the My Airports",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Banner Description (EN)",
      fieldValue: "type_description_en",
      className: "col-span-6",
      type: "text",
      name: "type_description_en",
      formType: "richText",
      label: "Banner Description (EN)",
      placeholder: "Enter Banner Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Banner Description (MS)",
      fieldValue: "type_description_ms",
      className: "col-span-6",
      type: "text",
      name: "type_description_ms",
      formType: "richText",
      label: "Banner Description (MS)",
      placeholder: "Enter Bannner Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Banner Description (ZH)",
      fieldValue: "type_description_zh",
      className: "col-span-6",
      type: "text",
      name: "type_description_zh",
      formType: "richText",
      label: "Banner Description (ZH)",
      placeholder: "Enter Bannner Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "redirect_url",
      className: "col-span-6",
      type: "text",
      name: "redirect_url",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "View More Text",
      fieldValue: "button_text",
      className: "col-span-6",
      type: "text",
      name: "button_text",
      formType: "input",
      label: "View More Text",
      placeholder: "Enter View More Text",
      validation: { required: "View More Text is required" },
    },
    {
      fieldName: "Sequence",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "input",
      label: "Sequence",
      placeholder: "Enter Sequence",
      // validation: { required: "View More Text is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedCategory: [
    {
      fieldName: "Web Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Web Image",
      placeholder: "Select Web Image",
      validation: { required: "Web Image is required" },
    },
    {
      fieldName: "Web Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Web Banner Image",
      placeholder: "Select Web Banner Image",
      validation: { required: "Web Banner Image is required" },
    },
    {
      fieldName: "Mobile Image",
      fieldValue: "mobile_image",
      className: "col-span-6",
      type: "image",
      name: "mobile_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Mobile Image",
      placeholder: "Select Mobile Image",
      // validation: { required: "Mobile Image is required" },
    },
    {
      fieldName: "Mobile Banner Image",
      fieldValue: "mobile_banner_image",
      className: "col-span-6",
      type: "image",
      name: "mobile_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Mobile Banner Image",
      placeholder: "Select Mobile Banner Image",
      // validation: { required: "Mobile Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Label",
      fieldValue: "label",
      className: "col-span-6",
      type: "text",
      name: "label",
      formType: "input",
      label: "Label",
      placeholder: "Enter Label",
      validation: { required: "Label is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Type",
      fieldValue: "type_reference_id",
      className: "col-span-6",
      type: "select",
      name: "type_reference_id",
      formType: "select",
      label: "Type",
      placeholder: "Select Type",
      loadOptions: fetchTypeShopSelection,
      validation: { required: "Type is required" },
    },
    // {
    //   fieldName: "Redirect Url",
    //   fieldValue: "link",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "link",
    //   formType: "input",
    //   label: "Redirect Url",
    //   placeholder: "Enter Redirect Url",
    //   // validation: { required: "Redirect Url is required" },
    // },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedSubCategory: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedList: [
    {
      fieldName: "Title / Outlet (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title / Outlet (EN)",
      placeholder: "Enter Title / Outlet (EN)",
      validation: { required: "Title / Outlet (EN) is required" },
    },
    {
      fieldName: "Title / Outlet (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title / Outlet (MS)",
      placeholder: "Enter Title / Outlet (MS)",
    },
    {
      fieldName: "Title / Outlet (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title / Outlet (ZH)",
      placeholder: "Enter Title / Outlet (ZH)",
    },

    // ---------------- OUTLET FIELDS ----------------
    // {
    //   fieldName: "Outlet",
    //   fieldValue: "outlet",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "outlet",
    //   formType: "input",
    //   label: "Outlet",
    //   placeholder: "Enter Outlet",
    // },
    {
      fieldName: "Store Time",
      fieldValue: "store_time",
      className: "col-span-6",
      type: "text",
      name: "store_time",
      formType: "input",
      label: "Store Time",
      placeholder: "Enter Store Time",
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "field_project_airport",
      className: "col-span-6",
      type: "select",
      name: "field_project_airport",
      formType: "select",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Location",
      fieldValue: "location_code",
      className: "col-span-6",
      type: "select",
      name: "location_code",
      formType: "select",
      label: "Location",
      placeholder: "Select Location",
      loadOptions: async (currentAirport: any) => {
        return FetchLocationAirport(currentAirport ?? "all");
      },
      note: "Please select the Modules / Airports before selecting Location",
      editable: false,
    },
    // {
    //   fieldName: "Source",
    //   fieldValue: "source",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "source",
    //   formType: "select",
    //   label: "Source",
    //   placeholder: "Enter Source",
    //   loadOptions: fetchSourceSelection,
    // },

    // ---------------- SELECT LIST FIELDS ----------------
    // {
    //   fieldName: "Brand",
    //   fieldValue: "brand",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "brand",
    //   formType: "select",
    //   label: "Brand",
    //   placeholder: "Select Brand",
    //   loadOptions: fetchBrandSelection,
    // },
    // {
    //   fieldName: "Type",
    //   fieldValue: "type_reference_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "type_reference_id",
    //   formType: "select",
    //   label: "Type",
    //   placeholder: "Select Type",
    //   loadOptions: fetchTypeShopSelection,
    // },
    // {
    //   fieldName: "Data Classification",
    //   fieldValue: "data_classification",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "data_classification",
    //   formType: "select",
    //   label: "Data Classification",
    //   placeholder: "Select Data Classification",
    //   loadOptions: fetchClassificationSelection,
    // },
    // {
    //   fieldName: "Type",
    //   fieldValue: "type",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "type",
    //   formType: "select",
    //   label: "Type",
    //   placeholder: "Select Type",
    //   loadOptions: fetchTypeShopStoreSelection,
    // },
    {
      fieldName: "Category",
      fieldValue: "shop_category",
      className: "col-span-6",
      type: "select",
      name: "shop_category",
      formType: "select",
      label: "Category",
      placeholder: "Select Category",
      loadOptions: fetchCategorySelection,
    },
    // {
    //   fieldName: "Sub Category",
    //   fieldValue: "sub_category",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "sub_category",
    //   formType: "select",
    //   label: "Sub Category",
    //   placeholder: "Select Sub Category",
    //   loadOptions: fetchSubCategorySelection,
    // },
    // {
    //   fieldName: "Tags",
    //   fieldValue: "tag",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "tag",
    //   formType: "multiInput",
    //   label: "Tags",
    //   placeholder: "Enter Tags",
    //   // loadOptions: fetchTagsShopSelection,
    // },
    {
      fieldName: "POI Type",
      fieldValue: "type_poi",
      className: "col-span-6",
      type: "select",
      name: "type_poi",
      formType: "select",
      label: "POI Type",
      placeholder: "Select POI Type",
      options: [
        {
          value: "location",
          label: "Location",
        },
        {
          value: "non-location",
          label: "Non-Location",
        },
      ],
    },

    {
      fieldName: "Zone",
      fieldValue: "centralize_zone",
      className: "col-span-6",
      type: "select",
      name: "centralize_zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "centralize_zone_level",
      className: "col-span-6",
      type: "select",
      name: "centralize_zone_level",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModuleCentralized(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },

    // {
    //   fieldName: "Redirect URL",
    //   fieldValue: "redirect_url_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "redirect_url_id",
    //   formType: "select",
    //   label: "Redirect URL",
    //   placeholder: "Select Redirect URL",
    //   loadOptions: fetchRedirectSelection,
    // },

    // ---------------- IMAGE FIELDS ----------------
    {
      fieldName: "Web Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      label: "Web Image",
      usedFileType: "image/*",
      placeholder: "Select Web Image",
      validation: { required: "Web Image is required" },
    },
    {
      fieldName: "Mobile Image",
      fieldValue: "mobile_image",
      className: "col-span-6",
      type: "image",
      name: "mobile_image",
      formType: "file",
      label: "Mobile Image",
      usedFileType: "image/*",
      placeholder: "Select Mobile Image",
      validation: { required: "Mobile Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      label: "Banner Image",
      usedFileType: "image/*",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },

    // ---------------- IMAGE DESCRIPTION ----------------
    {
      fieldName: "Image Description (EN)",
      fieldValue: "image_description",
      className: "col-span-6",
      type: "text",
      name: "image_description",
      formType: "richText",
      label: "Image Description (EN)",
      placeholder: "Enter Image Description",
      validation: { required: "Image Description (EN) is required" },
    },
    {
      fieldName: "Image Description (MS)",
      fieldValue: "image_description_malay",
      className: "col-span-6",
      type: "text",
      name: "image_description_malay",
      formType: "richText",
      label: "Image Description (MS)",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Image Description (ZH)",
      fieldValue: "image_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "image_description_mandarin",
      formType: "richText",
      label: "Image Description (ZH)",
      placeholder: "Enter Image Description",
    },

    // ---------------- SEO FIELDS ----------------
    {
      fieldName: "SEO Title",
      fieldValue: "seo_title",
      className: "col-span-6",
      type: "text",
      name: "seo_title",
      formType: "input",
      label: "SEO Title",
      placeholder: "Enter SEO Title",
    },
    {
      fieldName: "SEO Description",
      fieldValue: "seo_description",
      className: "col-span-6",
      type: "text",
      name: "seo_description",
      formType: "textarea",
      label: "SEO Description",
      placeholder: "Enter SEO Description",
    },

    {
      fieldName: "Closure Reason",
      fieldValue: "closure_reason",
      className: "col-span-6",
      type: "text",
      name: "closure_reason",
      formType: "input",
      label: "Closure Reason",
      placeholder: "Enter Closure Reason",
    },

    // ---------------- DATES ----------------
    {
      fieldName: "Start Date",
      fieldValue: "start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "start_date",
      formType: "dateTime",
      label: "Start Date",
      placeholder: "Enter Start Date",
    },
    {
      fieldName: "End Date",
      fieldValue: "end_state",
      className: "col-span-6",
      type: "dateTime",
      name: "end_state",
      formType: "dateTime",
      label: "End Date",
      placeholder: "Enter End Date",
    },

    // ---------------- CONTACT FIELDS ----------------
    {
      fieldName: "Phone",
      fieldValue: "phone",
      className: "col-span-6",
      type: "number",
      name: "phone",
      formType: "input",
      label: "Phone",
      placeholder: "Enter Phone Number",
    },
    {
      fieldName: "Email",
      fieldValue: "email",
      className: "col-span-6",
      type: "text",
      name: "email",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
    },

    // ---------------- LOCATION COORDINATES ----------------
    {
      fieldName: "Latitude",
      fieldValue: "latitude",
      className: "col-span-6",
      type: "number",
      name: "latitude",
      formType: "input",
      label: "Latitude",
      placeholder: "Enter Latitude",
    },
    {
      fieldName: "Longitude",
      fieldValue: "longitude",
      className: "col-span-6",
      type: "number",
      name: "longitude",
      formType: "input",
      label: "Longitude",
      placeholder: "Enter Longitude",
    },

    // ---------------- OTHER FIELDS ----------------
    {
      fieldName: "Regulatory Compliance",
      fieldValue: "regulatory_compliance",
      className: "col-span-6",
      type: "text",
      name: "regulatory_compliance",
      formType: "input",
      label: "Regulatory Compliance",
      placeholder: "Enter Regulatory Compliance",
    },
    // {
    //   fieldName: "Search Weight",
    //   fieldValue: "search_weight",
    //   className: "col-span-6",
    //   type: "number",
    //   name: "search_weight",
    //   formType: "input",
    //   label: "Search Weight",
    //   placeholder: "Enter Search Weight",
    // },
    // {
    //   fieldName: "Analytics ID",
    //   fieldValue: "analytics_id",
    //   className: "col-span-6",
    //   type: "number",
    //   name: "analytics_id",
    //   formType: "input",
    //   label: "Analytics ID",
    //   placeholder: "Enter Analytics ID",
    // },
    {
      fieldName: "Technical ID",
      fieldValue: "technical_id",
      className: "col-span-6",
      type: "number",
      name: "technical_id",
      formType: "input",
      label: "Technical ID",
      placeholder: "Enter Technical ID",
    },
    {
      fieldName: "Tenant ID",
      fieldValue: "tenant_id",
      className: "col-span-6",
      type: "number",
      name: "tenant_id",
      formType: "input",
      label: "Tenant ID",
      placeholder: "Enter Tenant ID",
    },

    // ---------------- BOOLEAN FIELDS ----------------
    {
      fieldName: "Is Active",
      fieldValue: "is_active",
      className: "col-span-12",
      type: "checkbox",
      name: "is_active",
      formType: "checkbox",
      label: "Is Active",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Temporarily Closed",
      fieldValue: "is_temporarily_closed",
      className: "col-span-12",
      type: "checkbox",
      name: "is_temporarily_closed",
      formType: "checkbox",
      label: "Temporarily Closed",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Gender Separated",
      fieldValue: "gender_separated",
      className: "col-span-12",
      type: "checkbox",
      name: "gender_separated",
      formType: "checkbox",
      label: "Gender Separated",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Braille Signage",
      fieldValue: "braille_signage",
      className: "col-span-12",
      type: "checkbox",
      name: "braille_signage",
      formType: "checkbox",
      label: "Braille Signage",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Wheel Chair",
      fieldValue: "wheel_chair",
      className: "col-span-12",
      type: "checkbox",
      name: "wheel_chair",
      formType: "checkbox",
      label: "Wheel Chair",
      placeholder: "Enter Image Description",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Image Description",
    },
  ],
  centralizedDataClassification: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedSource: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedLocation: [
    {
      fieldName: "Level (EN)",
      fieldValue: "level",
      className: "col-span-6",
      type: "text",
      name: "level",
      formType: "input",
      label: "Level (EN)",
      placeholder: "Enter Level (EN)",
      validation: { required: "Level (EN) is required" },
    },
    {
      fieldName: "Level (MS)",
      fieldValue: "level_malay",
      className: "col-span-6",
      type: "text",
      name: "level_malay",
      formType: "input",
      label: "Level (MS)",
      placeholder: "Enter Level (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Level (ZH)",
      fieldValue: "level_mandarin",
      className: "col-span-6",
      type: "text",
      name: "level_mandarin",
      formType: "input",
      label: "Level (ZH)",
      placeholder: "Enter Level (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Address (EN)",
      fieldValue: "address",
      className: "col-span-6",
      type: "text",
      name: "address",
      formType: "input",
      label: "Address (EN)",
      placeholder: "Enter Address (EN)",
      validation: { required: "Address (EN) is required" },
    },
    {
      fieldName: "Address (MS)",
      fieldValue: "address_malay",
      className: "col-span-6",
      type: "text",
      name: "address_malay",
      formType: "input",
      label: "Address (MS)",
      placeholder: "Enter Address (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Address (ZH)",
      fieldValue: "address_mandarin",
      className: "col-span-6",
      type: "text",
      name: "address_mandarin",
      formType: "input",
      label: "Address (ZH)",
      placeholder: "Enter Address (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "select",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionShopDine,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
